<template>
    <internal>
        <div
            class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg pb-48"
        >
            <loading :showLoading="form.processing"/>
            <div
                :class="{
                    'opacity-50': form.processing,
                    'opacity-100': !form.processing,
                }"
            >
                <p class="text-lg font-medium mb-4">Add Collection</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <FormMultiselect
                                :required="true"
                                label="Students"
                                :options="options"
                                track-key="id"
                                label-key="title"
                                return-key="id"
                                v-model="form.admission_id"
                                :placeholder="'Select Students'"
                                :error="form.errors.admission_id"
                            />
                        </div>

                        <div>
                            <breeze-label :required="true" value="Paid Date"/>
                            <breeze-input required type="date"
                                          v-model="form.paid_at"
                                          class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.paid_at:''"/>
                        </div>
                        <FormMultiselect
                            label="Payment Mode"
                            :options="payment_modes"
                            track-key="id"
                            label-key="title"
                            return-value="id"
                            v-model="form.payment_mode_id"
                            :error="form.errors.payment_mode_id"
                            :placeholder="'Select Payment Mode'"
                        />
                        <div>
                            <breeze-label :required="true" :value="'Amount'"/>
                            <breeze-input required type="number" v-model="form.amount" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.amount:''"/>
                        </div>
                        <div class="col-span-2">
                            <breeze-label :required="true" :value="'Remark'"/>
                            <textarea rows="3" v-model="form.remark" class="w-full rounded-md"></textarea>
                            <breeze-input-error :message="form.errors?form.errors.remark:''"/>
                        </div>
                    </div>

                    <div class></div>
                    <!--                                            <button-link :href="route('internal.weekschedule.list',branchid)" class="bg-red-500 mr-4 hover:bg-red-400">Cancel</button-link>-->
                    <breeze-button :disabled="form.processing">Submit</breeze-button>
                    <span
                        v-if="form.recentlySuccessful"
                        class="text-green-500 mx-4"
                    >Collection {{ studentCollection.length ? 'update' : 'added' }} success.</span>
                    <exception/>
                </form>
            </div>
        </div>
    </internal>
</template>

<script setup>
import Internal from "@/Pages/Internal/Internal";
import BreezeLabel from "@/Components/Label";
import Loading from "@/Components/Loading";
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import {computed, defineProps} from "vue";
import BreezeInput from "@/Components/Input";
import BreezeButton from "@/Components/Button";
import BreezeInputError from "@/Components/InputError";
import Exception from "@/Components/Exception";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

const payment_modes = computed(() => usePage().props.value?.payment_modes);

const props = defineProps({
    branch_id: String,
    adminssions: [],
    studentCollection: {
        type: Object,
        default: []
    }
});

const options = computed(() => {
    var users = [];
    props.adminssions.forEach(item => {
        users.push({
            id: item.id,
            title:
                item.student.first_name +
                " " +
                item.student.middle_name +
                " " +
                item.student.last_name
        });
    });
    return users;
});
const form = useForm({
    amount: props.studentCollection?.amount,
    remark: props.studentCollection?.remark,
    admission_id: props.studentCollection?.admission_id,
    payment_mode_id: props.studentCollection?.payment_mode_id ?? '',
    paid_at: props.studentCollection?.paid_at_date ?? '',
});


function submitForm() {

    if (props.studentCollection?.id) {
        form.post(route("internal.collection.update", [props.branch_id, props.studentCollection.id]),
            {
                preserveScroll: true,
                onSuccess: () => {

                }
            }
        );
    } else {
        form.post(route("internal.collection.create", props.branch_id), {
            onSuccess: () => {
                form.reset();
            }
        });
    }
}
</script>
